export default __webpack_public_path__ + "static/media/Nunito-Regular.f8c1d028.ttf";